import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, homeApi } from "../utils/constants";

export const homeData = createAsyncThunk("homeData", async () => {
    try {
        const config = {
            headers: {
                Authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFhYXNzc0B5b3BtYWlsLmNvbSIsImlkIjoiNjM4YzhhYTUtYzU0NC00YzcxLWI3YWEtZTI2ZjBlOGZkNzFiIiwidXNlclR5cGUiOiJVU0VSIiwicGxhdGZvcm0iOiJXRUIiLCJpYXQiOjE3NDAzNzg0MjJ9.qTM6H1yVzhMhNDHsvdUHgcP22Oed8aX5hbFh_YwEW4",
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
        };
        const url = ApiBaseUrl + homeApi;
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        alert(error.response.data.message);
        throw error.response.data;
    }
});
const HomeSlice = createSlice({
    name: "homeReducer",
    initialState: {
        isLoading: false,
        data: null,
    },
    reducers: {
        clearHomeData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(homeData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(homeData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(homeData.rejected, (state) => {
                state.isError = false;
            });
    },
});

export const { clearHomeData } = HomeSlice.actions;
export default HomeSlice.reducer;